import { TemplateRelationsApiFactory, TemplatesApiFactory } from '@mynt/backoffice-api-spec/templates'
import Axios from 'api/axios'
import config from 'config'
import type { CreateRelationRequest, RelationId, RelationUpdateRequest } from './api'
import {
  mapConnectedTemplateDtoToRelationTemplate,
  mapCreateRelationRequestToRelationRequestDto,
  mapRelationDtoToRelation,
  mapUpdateRelationRequestToPatchAction,
} from './mappers'

const relationsApi = TemplateRelationsApiFactory(undefined, config.boBaseUrl, Axios)
const templatesApi = TemplatesApiFactory(undefined, config.boBaseUrl, Axios)

export const getAllRelations = () => relationsApi.getAllRelations().then(({ data }) => data.map(mapRelationDtoToRelation))

export const getRelation = (relationId: RelationId) =>
  relationsApi.getRelation(relationId).then(({ data }) => mapRelationDtoToRelation(data))

export const updateRelation = (relationId: RelationId, updateRequest: RelationUpdateRequest[]) =>
  relationsApi.updateRelation(relationId, { relations: updateRequest.map(mapUpdateRelationRequestToPatchAction) })

export const createRelation = (relation: CreateRelationRequest) =>
  relationsApi.createRelation(mapCreateRelationRequestToRelationRequestDto(relation)).then(({ data }) => mapRelationDtoToRelation(data))

export const getRelationTemplates = () =>
  templatesApi.getAllTemplates().then(({ data }) => data.map(mapConnectedTemplateDtoToRelationTemplate))
